import * as React from "react";

export interface IProps {
    condition: boolean;
    children: JSX.Element;
}

export const If: React.SFC<IProps> = props => props.condition && props.children;